import { setupListeners } from '@reduxjs/toolkit/query';

import { configureRootStore } from 'store/configureRootStore';

const store = configureRootStore();

// enable listener behavior for the store
setupListeners(store.dispatch);

export default store;
